/**
 * Putting words in the composer from elsewhere on the page (handoff 3 §8, §11): a chip or a glance
 * cell asks, the docked composer fills in and takes focus. Nothing is sent until the reader sends it.
 */
const EVENT = "nira:compose"

/** The rupees prompt: an answer with no amount is worked out again once the reader gives one. */
export const RUPEES_PROMPT = "Work it out with the amounts: tax ₹"

export function compose(text: string): void {
  window.dispatchEvent(new CustomEvent<string>(EVENT, { detail: text }))
}

export function onCompose(fill: (text: string) => void): () => void {
  const listener = (e: Event) => fill((e as CustomEvent<string>).detail)
  window.addEventListener(EVENT, listener)
  return () => window.removeEventListener(EVENT, listener)
}
